import {
    Component,
    OnInit,
    OnDestroy,
    Output,
    Input,
    EventEmitter,
    AfterViewChecked,
    inject,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    DxAccordionModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxToolbarModule,
    DxLoadPanelModule,
    DxScrollViewModule,
    DxFormModule,
    DxValidatorModule,
    DxValidationGroupModule,
} from 'devextreme-angular';
import {
    ContactStatusComponent,
} from 'src/app/components';
import {ScreenService} from 'src/app/services';
import {distinctUntilChanged, Subject, Subscription} from 'rxjs';
import {Contact} from 'src/app/types/contact';

@Component({
    selector: 'filter-panel',
    templateUrl: './filter-panel.component.html',
    styleUrls: ['./filter-panel.component.scss'],
    providers: [],
    imports: [
        DxAccordionModule,
        DxButtonModule,
        DxDropDownButtonModule,
        DxToolbarModule,
        DxLoadPanelModule,
        DxScrollViewModule,
        DxFormModule,
        DxValidatorModule,
        DxValidationGroupModule,
        ContactStatusComponent,
        CommonModule,
    ]
})
export class FilterPanelComponent implements OnInit, AfterViewChecked, OnDestroy {
    @Input() isOpened = false;
    @Output() isOpenedChange = new EventEmitter<boolean>();
    @Output() pinnedChange = new EventEmitter<boolean>();
    @Output() onSearch = new EventEmitter<void>();
    @Output() onClear = new EventEmitter<void>();

    private pinEventSubject = new Subject<boolean>();
    private screen = inject(ScreenService);

    formData: Contact = {} as Contact;
    pinned = false;
    isLoading = false;
    isPinEnabled = false;
    userPanelSubscriptions: Subscription[] = [];

    constructor() {
        this.userPanelSubscriptions.push(
            this.screen.changed.subscribe(this.calculatePin),
            this
                .pinEventSubject
                .pipe(distinctUntilChanged())
                .subscribe(this.pinnedChange)
        );
    }

    ngOnInit(): void {
        this.calculatePin();
    }

    ngAfterViewChecked(): void {
        this.pinEventSubject.next(this.pinned);
    }

    ngOnDestroy(): void {
        this.userPanelSubscriptions.forEach((sub) => sub.unsubscribe());
    }

    onClosePanel = () => {
        this.isOpened = false;
        this.pinned = false;
        this.isOpenedChange.emit(this.isOpened);
    };

    onPinClick = () => {
        this.pinned = !this.pinned;
    };

    calculatePin = () => {
        this.isPinEnabled = this.screen.sizes['screen-large'] || this.screen.sizes['screen-medium'];
        if (this.pinned && !this.isPinEnabled) {
            this.pinned = false;
        }
    };

    protected search() {
        if(!this.pinned){
            this.isOpened = false;
            this.isOpenedChange.emit(this.isOpened);
        }
        this.onSearch.emit();
    }

    protected clear() {
        if(!this.pinned){
            this.isOpened = false;
            this.isOpenedChange.emit(this.isOpened);
        }
        this.onClear.emit();
    }
}
